module.exports = __webpack_public_path__ + "static/pfm-b10ae285e57756b746c8427327ee381c.svg";